<template>
  <v-container>
    <v-row v-if="currentActionRoute === 'onboardStatus'" class="justify-center">
      <div v-if="ebavStatusFlag === 'ERROR' && (applicationStatus === 'ACCOUNT_CREATE_SUCCESS' || applicationStatus === 'ACCOUNT_CREATE_FAILED')">
        <!-- this v-card is for EBAV failure screens start -->
      <v-card flat class="justify-center align-center">
        <h4
          class="onboarding-screenTitle text-none text-center pb-8"
          :style="{
            'font-family': customCSS && customCSS['formTitle-fontFamily'],
          }"
          v-if="$te(`onboardStatus.ebavScreenTitle`)"
        >
          {{ $t(`onboardStatus.ebavScreenTitle`) }}
        </h4>
        <div class="text-center">
          <img src="@/assets/dco/finalPage.png" class="finalScreen-Image" width="390px" />
        </div>
        <div class="pt-14">
          <div>
            <!--- Title -->
            <h3
              class="onboarding-title"
              :style="{
                'font-family': customCSS && customCSS['formTitle-fontFamily'],
              }"
              v-if="$te(`onboardStatus.idvComplaintEbavErrorSuccessTitle`) || $te(`onboardStatus.idvComplaintEbavErrorFailedTitle`)"
            >
              {{ applicationStatus === 'ACCOUNT_CREATE_SUCCESS' ? $t(`onboardStatus.idvComplaintEbavErrorSuccessTitle`) : $t(`onboardStatus.idvComplaintEbavErrorFailedTitle`) }}
            </h3>
            <p
              class="onboarding-subTitle2 mb-4 pt-4"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
              v-if="$te(`onboardStatus.idvComplaintEbavErrorHelper`)"
            > {{ $t(`onboardStatus.idvComplaintEbavErrorHelper`) }}
            </p>
            <p
              class="onboarding-subTitle2 mb-0"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
              v-if="$te(`onboardStatus.idvErrorContent`)"
            >
            <v-list class="pt-0">
              <v-list-item class="pa-0" v-for="(text, index) in $t(`onboardStatus.idvErrorContent`)" :key="index">
                <v-list-item-content class="pa-0">
                  <v-list-item-title style="white-space: normal; word-break: break-word;" class="onboarding-subTitle2 pa-0">
                    <v-icon class="mr-1" :color="customCSS && customCSS['onboardStatus-checkColor']">
                      {{ $appSettings.dco.onboardStatusScreen.icons.idvPendingEbavStatusError ? $appSettings.dco.onboardStatusScreen.icons.idvPendingEbavStatusError : 'mdi-check' }}
                    </v-icon>
                    <span>
                      {{ text }}
                    </span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            </p>
            <p
              class="onboarding-subTitle2 mb-2"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
              v-if="$te(`onboardStatus.idvHelpLineText`)"
            >
            {{ $t(`onboardStatus.idvHelpLineText`) }}
            <span class="font-weight-bold">{{ $t(`onboardStatus.helplineNumber`) }}</span>
            {{ $t(`onboardStatus.or`) }}
            <span class="font-weight-bold">{{ $t(`onboardStatus.helplineEmail`) }}</span>
            </p>
            <p
              class="onboarding-subTitle pt-4"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
              v-if="$te(`onboardStatus.idvPendingHelper1`)"
            >
              {{ $t(`onboardStatus.idvPendingHelper1`) }}
            </p>
            <div class="onboarding-summary-box" v-if="applicationStatus === 'ACCOUNT_CREATE_SUCCESS'" >
            <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-row justify-center align-center mb-0">
              <v-col sm="6" md="3" lg="3" class="justify-center align-center">
                <p
                  class="onboarding-subTitle1 mb-3"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.customerId`) }}
                </p>
                <h5
                  class="onboarding-content"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ partyId }}
                </h5>
              </v-col>
              <v-col sm="6" md="3" lg="3" class="justify-center align-center">
                <p
                  class="onboarding-subTitle1 mb-3"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.accountNumber`) }}
                </p>
                <h5
                  class="onboarding-content"
                  :style="{
                    'font-family': customCSS && customCSS['formTitle-fontFamily'],
                  }"
                >
                  {{ accountNumber }}
                </h5>
              </v-col>
            </v-row>
            </div>
            <div class="onboarding-summary-box" v-else>
            <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-row justify-center align-center mb-0">
              <v-col sm="6" md="3" lg="3" class="justify-center align-center">
                <p
                  class="onboarding-subTitle1 mb-3"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.customerId`) }}
                </p>
                <h5
                  class="onboarding-content"
                  :style="{
                    'font-family': customCSS && customCSS['formTitle-fontFamily'],
                  }"
                >
                  {{ partyId }}
                </h5>
              </v-col>
              <v-col sm="6" md="3" lg="3" class="justify-center align-center">
                <p
                  class="onboarding-subTitle1 mb-3"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.applicationNumber`) }}
                </p>
                <h5
                  class="onboarding-content"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ applicationNumber }}
                </h5>
              </v-col>
            </v-row>
            </div>
            <div class="text-center mt-16">
              <v-btn
            rounded
            :color="customCSS['primary']"
            outlined
            class="justify-center align-center text-center text-none"
            @click="customerService()"
          >
            {{$t(`onboardStatus.exit`)}}
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>
      <!-- this v-card is for LISA failure screens end -->
      </div>
      <div v-else-if="ebavStatusFlag === 'REFERRAL' && (applicationStatus === 'ACCOUNT_CREATE_SUCCESS' || applicationStatus === 'ACCOUNT_CREATE_FAILED')">
       <!-- this v-card is for EBAV Referral screens start -->
        <v-card flat class="justify-center align-center">
        <div class="text-center">
          <img src="@/assets/dco/finalPage.png" class="finalScreen-Image" width="390px" />
        </div>
        <div class="pt-14">
          <div>
            <!--- Title -->
            <h3
              class="onboarding-title"
              :style="{
                'font-family': customCSS && customCSS['formTitle-fontFamily'],
              }"
              v-if="$te(`onboardStatus.idvComplaintEbavReferralSuccessTitle`) || $te(`onboardStatus.idvComplaintEbavReferralFailedTitle`)"
            >
              {{ applicationStatus === 'ACCOUNT_CREATE_SUCCESS' ? $t(`onboardStatus.idvComplaintEbavReferralSuccessTitle`) : $t(`onboardStatus.idvComplaintEbavReferralFailedTitle`) }}
            </h3>
            <!---p tag with url has value-->
            <p
              class="onboarding-subTitle mb-0 onboarding-helper-centered"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
              v-if="((applicationStatus === 'ACCOUNT_CREATE_SUCCESS' || applicationStatus === 'ACCOUNT_CREATE_FAILED') && ebavLink !== null && ebavLink !== undefined)"
            >
              <span v-for="(text, index) in onboardHelper" :key="index">
                <template v-if="text === 'primaryUrl'">
                  <v-btn
                    v-if="ebavLink !== null"
                    rounded
                    text
                    :color="customCSS['primary']"
                    class="justify-center align-center text-lowercase px-1"
                    style="text-decoration: underline"
                    @click="redirectToThirdParty(ebavLink)"
                  >
                    {{ $t(`onboardStatus.pendingWithUrlBtn`) }}
                  </v-btn>
                </template>
                <template v-else>
                  {{ text }}
                </template>
              </span>
            </p>
            <p
              class="onboarding-subTitle2 mb-2"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
              v-if="((applicationStatus === 'ACCOUNT_CREATE_SUCCESS' || applicationStatus === 'ACCOUNT_CREATE_FAILED') && ebavLink !== null && ebavLink !== undefined)"
            >
            {{ onboardHelper1 }}
            <span class="font-weight-bold">{{ $t(`onboardStatus.helplineNumber`) }}</span>
            {{ $t(`onboardStatus.or`) }}
            <span class="font-weight-bold">{{ $t(`onboardStatus.helplineEmail`) }}</span>
            </p>
            <!--- p tag where url has no value -->
            <p
              class="onboarding-subTitle2 mb-2"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
              v-if="((applicationStatus === 'ACCOUNT_CREATE_SUCCESS' || applicationStatus === 'ACCOUNT_CREATE_FAILED') && ebavLink === null)"
            >
            {{ onboardHelper }}
            <span class="font-weight-bold">{{ $t(`onboardStatus.helplineNumber`) }}</span>
            {{ $t(`onboardStatus.or`) }}
            <span class="font-weight-bold">{{ $t(`onboardStatus.helplineEmail`) }}</span>
            </p>
            <!-- common p tag for both success and failure scenarios -->
            <p
              class="onboarding-subTitle pt-4"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
            > {{ onboardHelper2 }}
            </p>
            <div class="onboarding-summary-box" v-if="applicationStatus === 'ACCOUNT_CREATE_SUCCESS'">
            <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-row justify-center align-center mb-0" >
              <v-col sm="6" md="3" lg="3" class="justify-center align-center">
                <p
                  class="onboarding-subTitle1 mb-3"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.customerId`) }}
                </p>
                <h5
                  class="onboarding-content"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ partyId }}
                </h5>
              </v-col>
              <v-col sm="6" md="3" lg="3" class="justify-center align-center">
                <p
                  class="onboarding-subTitle1 mb-3"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.accountNumber`) }}
                </p>
                <h5
                  class="onboarding-content"
                  :style="{
                    'font-family': customCSS && customCSS['formTitle-fontFamily'],
                  }"
                >
                  {{ accountNumber }}
                </h5>
              </v-col>
            </v-row>
            </div>
            <div class="onboarding-summary-box" v-else>
            <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-row justify-center align-center mb-0">
              <v-col sm="6" md="3" lg="3" class="justify-center align-center">
                <p
                  class="onboarding-subTitle1 mb-3"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.customerId`) }}
                </p>
                <h5
                  class="onboarding-content"
                  :style="{
                    'font-family': customCSS && customCSS['formTitle-fontFamily'],
                  }"
                >
                  {{ partyId }}
                </h5>
              </v-col>
              <v-col sm="6" md="3" lg="3" class="justify-center align-center">
                <p
                  class="onboarding-subTitle1 mb-3"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.applicationNumber`) }}
                </p>
                <h5
                  class="onboarding-content"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ applicationNumber }}
                </h5>
              </v-col>
            </v-row>
            </div>
            <div class="text-center mt-16">
              <v-btn
            rounded
            :color="customCSS['primary']"
            outlined
            class="justify-center align-center text-center text-none"
            @click="customerService()"
          >
            {{$t(`onboardStatus.exit`)}}
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>
      </div>
      <div v-else-if="(applicationStatus === 'IDV_PENDING_EBAV_ACCEPTED')" >
        <!--this v-card is for EBAV referral IDV PENDING ACCEPTED -->
        <v-card flat class="justify-center align-center">
          <div class="text-center">
          <img src="@/assets/dco/finalPage.png" class="finalScreen-Image" width="390px" />
        </div>
        <div class="pt-14">
          <div>
            <h3
              class="onboarding-title"
              :style="{
                'font-family': customCSS && customCSS['formTitle-fontFamily'],
              }"
            >
              {{ onboardTitle }}
            </h3>
            <p
              class="onboarding-subTitle mb-0 onboarding-helper-centered"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
              v-if="(url !== null && url !== undefined)"
            >
              <span v-for="(text, index) in onboardHelper" :key="index">
                <template v-if="text === 'primaryUrl'">
                  <v-btn
                    v-if="url !== null"
                    rounded
                    text
                    :color="customCSS['primary']"
                    class="justify-center align-center text-lowercase px-1"
                    style="text-decoration: underline"
                    @click="redirectToThirdParty(url)"
                  >
                    {{ $t(`onboardStatus.pendingWithUrlBtn`) }}
                  </v-btn>
                </template>
                <template v-else>
                  {{ text }}
                </template>
              </span>
            </p>
            <p
              class="onboarding-subTitle2 mb-2"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
              v-else
            >
            {{ onboardHelper }}
            <span class="font-weight-bold">{{ $t(`onboardStatus.helplineNumber`) }}</span>
            {{ $t(`onboardStatus.or`) }}
            <span class="font-weight-bold">{{ $t(`onboardStatus.helplineEmail`) }}</span>
            </p>
            <p
              class="onboarding-subTitle2 mb-2"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
              v-if="(url !== null && url !== undefined)"
            >
            {{ $t(`onboardStatus.ebavReferralIdvPendingWithUrl2`) }}
            <span class="font-weight-bold">{{ $t(`onboardStatus.helplineNumber`) }}</span>
            {{ $t(`onboardStatus.or`) }}
            <span class="font-weight-bold">{{ $t(`onboardStatus.helplineEmail`) }}</span>
            </p>
            <p
              class="onboarding-subTitle pt-4"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
            > {{ onboardHelper1 }}
            </p>
            <div class="onboarding-summary-box">
            <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-row justify-center align-center mb-0">
              <v-col sm="6" md="3" lg="3" class="justify-center align-center">
                <p
                  class="onboarding-subTitle1 mb-3"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.customerId`) }}
                </p>
                <h5
                  class="onboarding-content"
                  :style="{
                    'font-family': customCSS && customCSS['formTitle-fontFamily'],
                  }"
                >
                  {{ partyId }}
                </h5>
              </v-col>
              <v-col sm="6" md="3" lg="3" class="justify-center align-center">
                <p
                  class="onboarding-subTitle1 mb-3"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                   {{ $t(`onboardStatus.applicationNumber`) }}
                </p>
                <h5
                  class="onboarding-content"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                   {{ applicationNumber }}
                </h5>
              </v-col>
            </v-row>
            </div>
            <div class="text-center mt-16">
              <v-btn
            rounded
            :color="customCSS['primary']"
            outlined
            class="justify-center align-center text-center text-none"
            @click="customerService()"
          >
            {{$t(`onboardStatus.exit`)}}
              </v-btn>
            </div>
          </div>
        </div>
        </v-card>
      </div>
      <div v-else-if="(applicationStatus === 'IDV_PENDING_EBAV_REFERRAL')">
        <!--this v-card is for EBAV referral IDV PENDING REFRRAL -->
          <v-card flat class="justify-center align-center">
          <div class="text-center">
          <img src="@/assets/dco/finalPage.png" class="finalScreen-Image" width="390px" />
        </div>
        <div class="pt-14">
          <div>
            <h3
              class="onboarding-title"
              :style="{
                'font-family': customCSS && customCSS['formTitle-fontFamily'],
              }"
            >
              {{ onboardTitle }}
            </h3>
            <!-- Below p tag is for url has value and ebavLink has value --->
            <p
            v-if="(url !== null && ebavLink !== null)">
            <span
              class="onboarding-subTitle2 mb-2 onboarding-helper-centered"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
            >
            {{ onboardHelper }}
            </span>
            <span
              class="onboarding-subTitle2 mb-0"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
              v-if="$te(`onboardStatus.idvPendingEbavStatusReferralWithUrlEbavLinkContent`)"
            >
            <v-list class="pt-0">
              <v-list-item class="pa-0" v-for="(text, index) in $t(`onboardStatus.idvPendingEbavStatusReferralWithUrlEbavLinkContent`)" :key="index">
                <v-list-item-content class="pa-0">
                  <v-list-item-title style="white-space: normal; word-break: break-word;" class="onboarding-subTitle2 pa-0">
                    <v-icon class="mr-1" :color="customCSS && customCSS['onboardStatus-iconColor']">
                      {{ $appSettings.dco.onboardStatusScreen.icons.ebavContent ? $appSettings.dco.onboardStatusScreen.icons.ebavContent : 'mdi-circle-small' }}
                    </v-icon>
                      <span v-for="(part, partIndex) in text.split(/{{|}}/).filter(Boolean)" :key="partIndex">
                       <template v-if="part === 'kycUrl'">
                        <v-btn
                        rounded
                        text
                        :color="customCSS['primary']"
                        class="justify-center align-center text-lowercase px-1"
                        style="text-decoration: underline"
                        @click="redirectToThirdParty(url)">
                       {{ $t('onboardStatus.pendingWithUrlBtn') }}
                        </v-btn>
                       </template>
                       <template v-else-if="part === 'ebavUrl'">
                       <v-btn
                        rounded
                        text
                        :color="customCSS['primary']"
                        class="justify-center align-center text-lowercase px-1"
                        style="text-decoration: underline"
                        @click="redirectToThirdParty(ebavLink)">
                        {{ $t('onboardStatus.pendingWithUrlBtn') }}
                       </v-btn>
                       </template>
                       <template v-else>
                        {{ part }}
                       </template>
                      </span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            </span>
            </p>
            <!-- Below p tag is for url has value and ebavLink has no value OR url has no value and ebav has value --->
            <p
              class="onboarding-subTitle mb-0 onboarding-helper-centered"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
              v-if="((url !== null && url !== undefined && ebavLink === null) || (url === null && ebavLink !== null && ebavLink !== undefined))"
            >
              <span v-for="(text, index) in onboardHelper" :key="index">
                <template v-if="text === 'primaryUrl'">
                  <v-btn
                    v-if="url !== null || ebavLink !== null"
                    rounded
                    text
                    :color="customCSS['primary']"
                    class="justify-center align-center text-lowercase px-1"
                    style="text-decoration: underline"
                    @click="url !== null ? redirectToThirdParty(url) : redirectToThirdParty(ebavLink)"
                  >
                    {{ $t(`onboardStatus.pendingWithUrlBtn`) }}
                  </v-btn>
                </template>
                <template v-else>
                  {{ text }}
                </template>
              </span>
            </p>
            <!-- Below p tag is for url has no value and ebavLink has no value common p tag for three screens --->
            <p
              class="onboarding-subTitle2 mb-2"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
            v-if = "((url !== null && ebavLink !== null) || (url=== null && ebavLink !== null) || (url !== null && ebavLink === null))"
            >
            {{ $t(`onboardStatus.idvHelpLineText`) }}
            <span class="font-weight-bold">{{ $t(`onboardStatus.helplineNumber`) }}</span>
            {{ $t(`onboardStatus.or`) }}
            <span class="font-weight-bold">{{ $t(`onboardStatus.helplineEmail`) }}</span>
            </p>
            <!-- Below p tag is for url has no value and ebavLink has no value --->
            <p
              class="onboarding-subTitle2 mb-2"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
              v-if = "(url === null && ebavLink === null)"
            >
            {{ onboardHelper }}
            <span class="font-weight-bold">{{ $t(`onboardStatus.helplineNumber`) }}</span>
            {{ $t(`onboardStatus.or`) }}
            <span class="font-weight-bold">{{ $t(`onboardStatus.helplineEmail`) }}</span>
            </p>
            <!-- Below p tag is for helper1 for all screens --->
            <p
              class="onboarding-subTitle pt-4"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
            > {{ onboardHelper1 }}
            </p>
            <div class="onboarding-summary-box">
              <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-row justify-center align-center mb-0">
              <v-col sm="6" md="3" lg="3" class="justify-center align-center">
                <p
                  class="onboarding-subTitle1 mb-3"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.customerId`) }}
                </p>
                <h5
                  class="onboarding-content"
                  :style="{
                    'font-family': customCSS && customCSS['formTitle-fontFamily'],
                  }"
                >
                  {{ partyId }}
                </h5>
              </v-col>
              <v-col sm="6" md="3" lg="3" class="justify-center align-center">
                <p
                  class="onboarding-subTitle1 mb-3"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                   {{ $t(`onboardStatus.applicationNumber`) }}
                </p>
                <h5
                  class="onboarding-content"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                   {{ applicationNumber }}
                </h5>
              </v-col>
            </v-row>
            </div>
            <div class="text-center mt-16">
              <v-btn
            rounded
            :color="customCSS['primary']"
            outlined
            class="justify-center align-center text-center text-none"
            @click="customerService()"
          >
            {{$t(`onboardStatus.exit`)}}
              </v-btn>
            </div>
          </div>
        </div>
        </v-card>
      </div>
      <div v-else-if="(applicationStatus === 'IDV_PENDING_EBAV_ERROR' || applicationStatus === 'CUSTOMER_CREATE_SUCCESS_EBAV_ERROR')">
         <!--this v-card is for EBAV referral IDV PENDING ERROR -->
          <v-card flat class="justify-center align-center">
          <div class="text-center">
          <img src="@/assets/dco/finalPage.png" class="finalScreen-Image" width="390px" />
        </div>
        <div class="pt-14">
          <div>
            <h3
              class="onboarding-title"
              :style="{
                'font-family': customCSS && customCSS['formTitle-fontFamily'],
              }"
            >
              {{ onboardTitle }}
            </h3>
            <!--- Below p tag is common HELPER for both IDV ERROR scenarios --->
            <p
              class="onboarding-subTitle2 mb-2"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
            >
            {{ onboardHelper }}
            </p>
            <!--- Below p tag is common content for both IDV ERROR scenarios --->
            <p
              class="onboarding-subTitle2 mb-0"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
              v-if="$te(`onboardStatus.idvErrorContent`)"
            >
            <v-list class="pt-0">
              <v-list-item class="pa-0" v-for="(text, index) in $t(`onboardStatus.idvErrorContent`)" :key="index">
                <v-list-item-content class="pa-0">
                  <v-list-item-title style="white-space: normal; word-break: break-word;" class="onboarding-subTitle2 pa-0">
                    <v-icon class="mr-1" :color="customCSS && customCSS['onboardStatus-checkColor']">
                      {{ $appSettings.dco.onboardStatusScreen.icons.idvPendingEbavStatusError ? $appSettings.dco.onboardStatusScreen.icons.idvPendingEbavStatusError : 'mdi-check' }}
                    </v-icon>
                    <span>
                      {{ text }}
                    </span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            </p>
            <!-- Below p tag is for url has value --->
            <p
              class="onboarding-subTitle mb-0 onboarding-helper-centered"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
              v-if="(applicationStatus === 'IDV_PENDING_EBAV_ERROR' && url !== null && url !== undefined)"
            >
              <span v-for="(text, index) in onboardHelper2" :key="index">
                <template v-if="text === 'primaryUrl'">
                  <v-btn
                    v-if="url !== null || ebavLink !== null"
                    rounded
                    text
                    :color="customCSS['primary']"
                    class="justify-center align-center text-lowercase px-1"
                    style="text-decoration: underline"
                    @click="redirectToThirdParty(url)"
                  >
                    {{ $t(`onboardStatus.pendingWithUrlBtn`) }}
                  </v-btn>
                </template>
                <template v-else>
                  {{ text }}
                </template>
              </span>
            </p>
            <!-- Below p tag is common for ERROR scenarios --->
            <p
              class="onboarding-subTitle2 mb-2"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
            >
            {{ $t(`onboardStatus.idvHelpLineText`) }}
            <span class="font-weight-bold">{{ $t(`onboardStatus.helplineNumber`) }}</span>
            {{ $t(`onboardStatus.or`) }}
            <span class="font-weight-bold">{{ $t(`onboardStatus.helplineEmail`) }}</span>
            </p>
            <p
              class="onboarding-subTitle pt-4"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
            > {{ onboardHelper1 }}
            </p>
            <div class="onboarding-summary-box">
            <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-row justify-center align-center mb-0">
              <v-col sm="6" md="3" lg="3" class="justify-center align-center">
                <p
                  class="onboarding-subTitle1 mb-3"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.customerId`) }}
                </p>
                <h5
                  class="onboarding-content"
                  :style="{
                    'font-family': customCSS && customCSS['formTitle-fontFamily'],
                  }"
                >
                  {{ partyId }}
                </h5>
              </v-col>
              <v-col sm="6" md="3" lg="3" class="justify-center align-center">
                <p
                  class="onboarding-subTitle1 mb-3"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                   {{ $t(`onboardStatus.applicationNumber`) }}
                </p>
                <h5
                  class="onboarding-content"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                   {{ applicationNumber }}
                </h5>
              </v-col>
            </v-row>
            </div>
            <div class="text-center mt-16">
              <v-btn
            rounded
            :color="customCSS['primary']"
            outlined
            class="justify-center align-center text-center text-none"
            @click="customerService()"
          >
            {{$t(`onboardStatus.exit`)}}
              </v-btn>
            </div>
          </div>
        </div>
        </v-card>
      </div>
      <div v-else>
      <!-- this v-card is to handle the final screens with different application status start -->
      <v-card flat class="justify-center align-center" v-if="isLisaError === ''">
        <h4
          class="onboarding-screenTitle text-none text-center pb-14"
          :style="{
            'font-family': customCSS && customCSS['formTitle-fontFamily'],
          }"
          v-if="
            partyCreationFailed === true ||
            secondaryPartyFailed === true ||
            applicationDown === true ||
            applicationStatus === 'ACCOUNT_CREATE_FAILED'
          "
        >
          <v-icon color="error">mdi-alert-circle-outline</v-icon>
          {{ screenTitle }}
        </h4>
        <div class="text-center">
          <img src="@/assets/dco/finalPage.png" class="finalScreen-Image" />
        </div>
        <div class="pt-14">
          <div v-if="!partyCreationFailed && !secondaryPartyFailed && !applicationDown">
            <h3
              class="onboarding-title mb-4"
              :style="{
                'font-family': customCSS && customCSS['formTitle-fontFamily'],
              }"
            >
              {{ onboardTitle }}
            </h3>
            <p
              class="onboarding-subTitle mb-0"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
              v-if="
                (url !== null && url !== undefined) ||
                (secondaryApplicantUrl !== null && secondaryApplicantUrl !== undefined)
              "
            >
              <span v-for="(text, index) in onboardHelper" :key="index">
                <template v-if="text === 'primaryUrl'">
                  <v-btn
                    v-if="url !== null"
                    rounded
                    text
                    :color="customCSS['primary']"
                    class="justify-center align-center text-lowercase px-1"
                    style="text-decoration: underline"
                    @click="redirectToThirdParty(url)"
                  >
                    {{ $t(`onboardStatus.pendingWithUrlBtn`) }}
                  </v-btn>
                </template>
                <template v-else-if="text === 'secondaryUrl'">
                  <v-btn
                    v-if="secondaryApplicantUrl !== null"
                    rounded
                    text
                    :color="customCSS['primary']"
                    class="justify-center align-center text-lowercase px-1"
                    style="text-decoration: underline"
                    @click="redirectToThirdParty(secondaryApplicantUrl)"
                  >
                    {{ $t(`onboardStatus.pendingWithUrlBtn`) }}
                  </v-btn>
                </template>
                <template v-else>
                  {{ text }}
                </template>
              </span>
              <span
                class="onboarding-subTitle mb-0"
                :style="{
                  'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                }"
                v-if="applicationStatus !== 'ACCOUNT_CREATE_SUCCESS' && applicationStatus !== 'CUSTOMER_CREATE_SUCCESS_IDV_FAILURE'"
              >
                {{ onboardHelper1 }}
                <span class="font-weight-bold">{{ $t(`onboardStatus.helplineNumber`) }}</span>
                {{ $t(`onboardStatus.or`) }}
                <span class="font-weight-bold">{{ $t(`onboardStatus.helplineEmail`) }}</span>
              </span>
            </p>
            <p
              class="onboarding-subTitle mb-0"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
              v-else-if="onboardHelper !== ''"
            >
              {{ onboardHelper }}
              <span
                class="onboarding-subTitle mb-0"
                :style="{
                  'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                }"
                v-if="applicationStatus !== 'ACCOUNT_CREATE_SUCCESS' && applicationStatus !== 'CUSTOMER_CREATE_SUCCESS_IDV_FAILURE'"
              >
                {{ onboardHelper1 }}
                <span class="font-weight-bold">{{ $t(`onboardStatus.helplineNumber`) }}</span>
                {{ $t(`onboardStatus.or`) }}
                <span class="font-weight-bold">{{ $t(`onboardStatus.helplineEmail`) }}</span>
              </span>
              <span
              class= "onboarding-subTitle mb-0"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
              v-if="applicationStatus === 'CUSTOMER_CREATE_SUCCESS_IDV_FAILURE' && onboardHelperIdvFailure !== ''"
              >
              {{onboardHelperIdvFailure}}
              <span class="font-weight-bold">{{ $t(`onboardStatus.helplineNumber`) }}</span>
                {{ $t(`onboardStatus.or`) }}
                <span class="font-weight-bold">{{ $t(`onboardStatus.helplineEmail`) }}</span>
              </span>
            </p>
            <p
              class="pendingWithHelper mb-0"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
              v-else-if="onboardHelper === ''"
            >
              <span>
            <p :style= "{'text-align': 'center'}"> {{$t(`onboardStatus.pendingWithHelper`)}}
             <v-btn
                    rounded
                    text
                    :color="customCSS['primary']"
                    class="justify-center align-center text-lowercase px-1"
                    style="text-decoration: underline"
                    @click="redirectToThirdParty(bankSite)"
                  >{{ $t(`onboardStatus.here`) }}</v-btn> </p>
            <p>{{$t(`onboardStatus.pendingSubtTitleOne`)}}</p>
            <p>{{$t(`onboardStatus.pendingAddressOne`)}}</p>
            <p>{{$t(`onboardStatus.pendingAddressTwo`)}}</p>
            <p>{{$t(`onboardStatus.pendingAddressThree`)}}</p>
            <p>{{$t(`onboardStatus.pendingAddressFour`)}}</p>
            <p>{{$t(`onboardStatus.pendingAddressFive`)}}</p>
            </span>
            </p>
          </div>
          <div class="justify-center align-center mt-8">
            <v-row
            class="onboarding-summary-box"
              v-if="
                applicationStatus === 'ACCOUNT_CREATE_SUCCESS' &&
                secondaryPartyId !== null &&
                partyId !== null
              "
            >
              <v-col cols="12" md="6" sm="6" lg="6" xl="6">
                <v-row class="justify-center">
                  <p
                    v-if="secondaryPartyId !== null"
                    class="onboarding-subTitle"
                    :style="{
                      'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    }"
                  >
                    {{ $t(`onboardStatus.primaryCustomerDetails`) }}
                  </p>
                </v-row>
                <v-row
                  class="justify-space-around"
                  v-if="secondaryPartyId !== null && secondaryPartyId !== null"
                >
                  <v-col cols="6">
                    <p
                      class="onboarding-subTitle1 mb-2"
                      :style="{
                        'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                      }"
                    >
                      {{ $t(`onboardStatus.customerId`) }}
                    </p>
                    <h5
                      class="onboarding-content"
                      :style="{
                        'font-family': customCSS && customCSS['formTitle-fontFamily'],
                      }"
                    >
                      {{ partyId }}
                    </h5>
                  </v-col>
                  <v-col cols="6">
                    <p
                      class="onboarding-subTitle1"
                      :style="{
                        'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                      }"
                    >
                      {{ $t(`onboardStatus.accountNumber`) }}
                    </p>
                    <h5
                      class="onboarding-content"
                      :style="{
                        'font-family': customCSS && customCSS['formTitle-fontFamily'],
                      }"
                    >
                      {{ accountNumber }}
                    </h5>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6" sm="6" lg="6" xl="6">
                <v-row class="justify-center">
                  <p
                    class="onboarding-subTitle"
                    :style="{
                      'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    }"
                  >
                    {{ $t(`onboardStatus.secondaryCustomerDetails`) }}
                  </p>
                </v-row>
                <v-row class="justify-space-around">
                  <v-col cols="6">
                    <p
                      class="onboarding-subTitle1 mb-2"
                      :style="{
                        'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                      }"
                    >
                      {{ $t(`onboardStatus.customerId`) }}
                    </p>
                    <h5
                      class="onboarding-content"
                      :style="{
                        'font-family': customCSS && customCSS['formTitle-fontFamily'],
                      }"
                    >
                      {{ secondaryPartyId }}
                    </h5>
                  </v-col>
                  <v-col cols="6">
                    <p
                      class="onboarding-subTitle1"
                      :style="{
                        'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                      }"
                    >
                      {{ $t(`onboardStatus.accountNumber`) }}
                    </p>
                    <h5
                      class="onboarding-content"
                      :style="{
                        'font-family': customCSS && customCSS['formTitle-fontFamily'],
                      }"
                    >
                      {{ accountNumber }}
                    </h5>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row
              v-else-if="
                secondaryPartyId !== null &&
                partyId !== null &&
                !applicationDown &&
                applicationStatus !== 'CUSTOMER_CREATE_SUCCESS_SECONDARY_CUSTOMER_BLOCKED' &&
                applicationStatus !== 'CUSTOMER_CREATE_SUCCESS_WITH_PRIMARY_IDV_PENDING_SECONDARY_CUSTOMER_BLOCKED'  &&
                applicationStatus !== 'ACCOUNT_CREATE_FAILED'
              "
              class="d-flex flex-row justify-center align-center"
            >
              <v-col sm="6" md="6" lg="6" class="justify-center align-center">
                <p
                  class="onboarding-subTitle"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.primaryCustomerDetails`) }}
                </p>
                <p
                  class="onboarding-subTitle1 mb-2"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.customerId`) }}
                </p>
                <h5
                  class="onboarding-content"
                  :style="{
                    'font-family': customCSS && customCSS['formTitle-fontFamily'],
                  }"
                >
                  {{ partyId }}
                </h5>
              </v-col>
              <v-col sm="6" md="6" lg="6" class="justify-center align-center">
                <p
                  class="onboarding-subTitle"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.secondaryCustomerDetails`) }}
                </p>
                <p
                  class="onboarding-subTitle1 mb-2"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.customerId`) }}
                </p>
                <h5
                  class="onboarding-content"
                  :style="{
                    'font-family': customCSS && customCSS['formTitle-fontFamily'],
                  }"
                >
                  {{ secondaryPartyId }}
                </h5>
              </v-col>
            </v-row>
            <v-row
              v-else-if="
                applicationStatus === 'ACCOUNT_CREATE_SUCCESS' &&
                secondaryPartyId === null &&
                partyId !== null
              "
              class="d-flex flex-column justify-center onboarding-summary-box"
            >
            <v-row class="d-flex justify-center"
              >
                <p
                  class="onboarding-subTitle mb-0 mt-3"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.accountCreationFailHelper1`) }}
                </p>
              </v-row>
                <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-row justify-center align-center mb-0">
              <v-col sm="6" md="6" lg="6" class="justify-center align-center">
                <p
                  class="onboarding-subTitle1 mb-3"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.customerId`) }}
                </p>
                <h5
                  class="onboarding-content"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ partyId }}
                </h5>
              </v-col>
              <v-col sm="6" md="6" lg="6" class="justify-center align-center">
                <p
                  class="onboarding-subTitle1 mb-3"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.accountNumber`) }}
                </p>
                <h5
                  class="onboarding-content"
                  :style="{
                    'font-family': customCSS && customCSS['formTitle-fontFamily'],
                  }"
                >
                  {{ accountNumber }}
                </h5>
              </v-col>
                </v-row>
              </v-row>
            <v-row
              v-else-if="applicationStatus === 'ACCOUNT_CREATE_FAILED'"
              class="d-flex flex-column"
            >
              <v-row
                v-if="secondaryPartyId === null || secondaryPartyId === undefined"
                class="d-flex justify-center"
              >
                <p
                  class="onboarding-subTitle mb-0"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.accountCreationFailHelper1`) }}
                </p>
              </v-row>
              <v-row
                class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-row justify-center align-center mb-0"
                v-if="secondaryPartyId === null || secondaryPartyId === undefined"
              >
                <v-col cols="5">
                  <p
                    class="onboarding-subTitle1"
                    :style="{
                      'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    }"
                  >
                    {{ $t(`onboardStatus.applicationNumber`) }}
                  </p>
                  <h5
                    class="onboarding-content"
                    :style="{
                      'font-family': customCSS && customCSS['formTitle-fontFamily'],
                    }"
                  >
                    {{ applicationNumber }}
                  </h5>
                </v-col>
                <v-col cols="5" v-if="partyId !== null">
                  <p
                    class="onboarding-subTitle1 mb-2"
                    :style="{
                      'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    }"
                  >
                    {{ $t(`onboardStatus.customerId`) }}
                  </p>
                  <h5
                    class="onboarding-content"
                    :style="{
                      'font-family': customCSS && customCSS['formTitle-fontFamily'],
                    }"
                  >
                    {{ partyId }}
                  </h5>
                </v-col>
              </v-row>
              <v-row class="justify-center align-center mb-0" v-if="secondaryPartyId !== null">
                <v-col cols="6">
                  <v-row class="justify-center">
                    <p
                      class="onboarding-subTitle"
                      :style="{
                        'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                      }"
                    >
                      {{ $t(`onboardStatus.primaryCustomerDetails`) }}
                    </p>
                  </v-row>
                  <v-row
                    class="justify-space-around d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column"
                  >
                    <v-col cols="12" md="6" sm="6" lg="6" xl="6">
                      <p
                        class="onboarding-subTitle1 mb-2"
                        :style="{
                          'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                        }"
                      >
                        {{ $t(`onboardStatus.customerId`) }}
                      </p>
                      <h5
                        class="onboarding-content"
                        :style="{
                          'font-family': customCSS && customCSS['formTitle-fontFamily'],
                        }"
                      >
                        {{ partyId }}
                      </h5>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-row class="justify-center">
                    <p
                      class="onboarding-subTitle"
                      :style="{
                        'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                      }"
                    >
                      {{ $t(`onboardStatus.secondaryCustomerDetails`) }}
                    </p>
                  </v-row>
                  <v-row
                    class="justify-space-around d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column"
                  >
                    <v-col cols="12" md="6" sm="6" lg="6" xl="6">
                      <p
                        class="onboarding-subTitle1 mb-2"
                        :style="{
                          'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                        }"
                      >
                        {{ $t(`onboardStatus.customerId`) }}
                      </p>
                      <h5
                        class="onboarding-content"
                        :style="{
                          'font-family': customCSS && customCSS['formTitle-fontFamily'],
                        }"
                      >
                        {{ secondaryPartyId }}
                      </h5>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-row>
            <v-row
              v-else-if="
                !applicationDown &&
                (applicationStatus === 'CUSTOMER_CREATE_SUCCESS_IDV_FAILURE' ||
                  applicationStatus === 'CUSTOMER_CREATE_SUCCESS_SECONDARY_CUSTOMER_BLOCKED' || applicationStatus === 'CUSTOMER_CREATE_SUCCESS_WITH_PRIMARY_IDV_PENDING_SECONDARY_CUSTOMER_BLOCKED')
              "
            >
              <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-row justify-center align-center mb-0">
                <v-col sm="6" md="3" lg="3" v-if="applicationStatus === 'CUSTOMER_CREATE_SUCCESS_IDV_FAILURE'">
                  <p
                    class="onboarding-subTitle1"
                    :style="{
                      'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    }"
                  >
                    {{ $t(`onboardStatus.applicationNumber`) }}
                  </p>
                  <h5
                    class="onboarding-content"
                    :style="{
                      'font-family': customCSS && customCSS['formTitle-fontFamily'],
                    }"
                  >
                    {{ applicationNumber }}
                  </h5>
                </v-col>
                <v-col sm="6" md="3" lg="3" v-if="applicationStatus === 'CUSTOMER_CREATE_SUCCESS_IDV_FAILURE'">
                  <p
                    class="onboarding-subTitle1"
                    :style="{
                      'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    }"
                  >
                    {{ $t(`onboardStatus.customerId`) }}
                  </p>
                  <h5
                    class="onboarding-content"
                    :style="{
                      'font-family': customCSS && customCSS['formTitle-fontFamily'],
                    }"
                  >
                    {{ partyId }}
                  </h5>
                </v-col>
                <v-col
                  cols="6"
                  class="justify-center align-center"
                  v-if="applicationStatus === 'CUSTOMER_CREATE_SUCCESS_SECONDARY_CUSTOMER_BLOCKED' || applicationStatus === 'CUSTOMER_CREATE_SUCCESS_WITH_PRIMARY_IDV_PENDING_SECONDARY_CUSTOMER_BLOCKED'"
                >
                  <p
                    class="onboarding-subTitle"
                    :style="{
                      'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    }"
                  >
                    {{ $t(`onboardStatus.primaryCustomerDetails`) }}
                  </p>
                  <p
                    class="onboarding-subTitle1 mb-2"
                    :style="{
                      'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    }"
                  >
                    {{ $t(`onboardStatus.customerId`) }}
                  </p>
                  <h5
                    class="onboarding-content"
                    :style="{
                      'font-family': customCSS && customCSS['formTitle-fontFamily'],
                    }"
                  >
                    {{ partyId }}
                  </h5>
                </v-col>
                <v-col
                  cols="6"
                  class="justify-center align-center"
                  v-if="applicationStatus === 'CUSTOMER_CREATE_SUCCESS_SECONDARY_CUSTOMER_BLOCKED' || applicationStatus === 'CUSTOMER_CREATE_SUCCESS_WITH_PRIMARY_IDV_PENDING_SECONDARY_CUSTOMER_BLOCKED'"
                >
                  <p
                    class="onboarding-subTitle"
                    :style="{
                      'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    }"
                  >
                    {{ $t(`onboardStatus.secondaryCustomerDetails`) }}
                  </p>
                  <p
                    class="onboarding-subTitle"
                    :style="{
                      'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    }"
                  >
                    -
                  </p>
                </v-col>
              </v-row>
            </v-row>
            <v-row
              v-else-if="partyId !== null && !secondaryPartyFailed && !applicationDown"
              class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column justify-center align-center mb-0"
            >
              <div>
                <p
                  class="onboarding-subTitle"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                 {{$te(`onboardStatus.accountCreationFailHelper1`) ? $t(`onboardStatus.accountCreationFailHelper1`) : $t(`onboardStatus.pendingSubTitleTwo`)}}
                </p>
              </div>
              <div class="d-flex flex-row justify-center align-center onboarding-summary-box">
                <v-col cols="12" sm="6" md="6" lg="12" class="justify-center align-center">
                  <p
                    class="onboarding-subTitle1"
                    :style="{
                      'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    }"
                  >
                    {{ $t(`onboardStatus.applicationNumber`) }}
                  </p>
                  <h5
                    class="onboarding-content"
                    :style="{
                      'font-family': customCSS && customCSS['formTitle-fontFamily'],
                    }"
                  >
                    {{ applicationNumber }}
                  </h5>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="12" class="justify-center align-center">
                  <p
                    class="onboarding-subTitle1 mb-3"
                    :style="{
                      'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    }"
                  >
                    {{ $t(`onboardStatus.customerId`) }}
                  </p>
                  <h5
                    class="onboarding-content"
                    :style="{
                      'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    }"
                  >
                    {{ partyId }}
                  </h5>
                </v-col>
              </div>
            </v-row>
            <div v-else-if="partyCreationFailed || secondaryPartyFailed" class="">
              <h3
                class="onboarding-title mb-4"
                :style="{
                  'font-family': customCSS && customCSS['formTitle-fontFamily'],
                }"
              >
                {{ onboardTitle }}
              </h3>
              <p
                class="onboarding-subTitle"
                :style="{
                  'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                }"
              >
                {{ onboardHelper }}
                <span class="font-weight-bold">{{ $t(`onboardStatus.helplineNumber`) }}</span>
                {{ $t(`onboardStatus.or`) }}
                <span class="font-weight-bold">{{ $t(`onboardStatus.helplineEmail`) }}</span
                >.
              </p>
              <p
                class="onboarding-subTitle"
                :style="{
                  'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                }"
              >
                {{ $t(`onboardStatus.accountCreationFailHelper1`) }}
              </p>
              <v-row
                class="justify-center align-center mt-8 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column onboarding-summary-box"
                v-if="partyCreationFailed === true"
              >
                <v-col cols="12">
                  <p
                    class="onboarding-subTitle1"
                    :style="{
                      'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    }"
                  >
                    {{ $t(`onboardStatus.applicationNumber`) }}
                  </p>
                  <h5
                    class="onboarding-content"
                    :style="{
                      'font-family': customCSS && customCSS['formTitle-fontFamily'],
                    }"
                  >
                    {{ applicationNumber }}
                  </h5>
                </v-col>
              </v-row>
              <v-row class="justify-center align-center mt-8" v-if="secondaryPartyFailed === true">
                <v-col cols="12" md="6" sm="6" lg="6" xl="6">
                  <v-row class="justify-center">
                    <p
                      class="onboarding-subTitle"
                      :style="{
                        'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                      }"
                    >
                      {{ $t(`onboardStatus.primaryCustomerDetails`) }}
                    </p>
                  </v-row>
                  <v-row class="justify-space-around d-flex">
                    <v-col cols="6">
                      <p
                        class="onboarding-subTitle1 mb-2"
                        :style="{
                          'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                        }"
                      >
                        {{ $t(`onboardStatus.customerId`) }}
                      </p>
                      <h5
                        class="onboarding-content"
                        :style="{
                          'font-family': customCSS && customCSS['formTitle-fontFamily'],
                        }"
                      >
                        {{ partyId }}
                      </h5>
                    </v-col>
                    <v-col cols="6">
                      <p
                        class="onboarding-subTitle1 mb-2"
                        :style="{
                          'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                        }"
                      >
                        {{ $t(`onboardStatus.applicationNumber`) }}
                      </p>
                      <h5
                        class="onboarding-content"
                        :style="{
                          'font-family': customCSS && customCSS['formTitle-fontFamily'],
                        }"
                      >
                        {{ applicationNumber }}
                      </h5>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" sm="6" lg="6" xl="6">
                  <v-row class="justify-center">
                    <p
                      class="onboarding-subTitle"
                      :style="{
                        'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                      }"
                    >
                      {{ $t(`onboardStatus.secondaryCustomerDetails`) }}
                    </p>
                  </v-row>
                  <v-row
                    class="justify-space-around d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column"
                  >
                    <v-col cols="12" md="6" sm="6" lg="6" xl="6">
                      <p
                        class="onboarding-subTitle1 mb-2"
                        :style="{
                          'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                        }"
                      >
                        {{ $t(`onboardStatus.applicationNumber`) }}
                      </p>
                      <h5
                        class="onboarding-content"
                        :style="{
                          'font-family': customCSS && customCSS['formTitle-fontFamily'],
                        }"
                      >
                        {{ applicationNumber }}
                      </h5>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            <v-row v-else-if="applicationDown === true" class="d-flex justify-center align-center">
              <h3
                class="onboarding-title mb-4"
                :style="{
                  'font-family': customCSS && customCSS['formTitle-fontFamily'],
                }"
              >
                {{ onboardTitle }}
              </h3>
              <p
                class="onboarding-subTitle"
                :style="{
                  'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                }"
              >
                {{ onboardHelper }}
                <span class="font-weight-bold">{{ $t(`onboardStatus.helplineNumber`) }}</span>
                {{ $t(`onboardStatus.or`) }}
                <span class="font-weight-bold">{{ $t(`onboardStatus.helplineEmail`) }}</span
                >.
              </p>
              <v-row class="d-flex justify-center align-center mb-0 onboarding-summary-box">
                <v-col cols="6" offset="">
                  <p
                    class="onboarding-subTitle1"
                    :style="{
                      'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    }"
                  >
                    {{ $t(`onboardStatus.applicationNumber`) }}
                  </p>
                  <h5
                    class="onboarding-content"
                    :style="{
                      'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    }"
                  >
                    {{ applicationNumber }}
                  </h5>
                </v-col>
              </v-row>
            </v-row>
            <br/>
          <span v-if="$t(`onboardStatus.pendingFinalHelperText !== ''`)">
               <p class="manual-text"
          :style="{
            'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
            'text-align': 'center'
          }" >{{$t(`onboardStatus.pendingFinalHelperText`)}}
          <v-btn
          v-if="$t(`onboardStatus.pendingFinalHelperText`)!== ''"
          rounded
          text
          :color="customCSS['primary']"
          class="justify-center align-center text-lowercase px-1"
          style="text-decoration: underline"
          @click="redirectToThirdParty(bankSiteLink)"
          >
          {{ $t(`onboardStatus.home`) }}
          </v-btn>
          </p>
          </span>
          </div>
        </div>
        <div class="text-center mt-16">
          <v-btn
            rounded
            :color="customCSS['primary']"
            :outlined="applicationStatus !== 'ACCOUNT_CREATE_SUCCESS'"
            :class="
              applicationStatus !== 'ACCOUNT_CREATE_SUCCESS'
                ? 'justify-center align-center text-center text-none'
                : 'justify-center align-center text-center text-none white--text'
            "
            @click="
              applicationStatus === 'ACCOUNT_CREATE_SUCCESS'
                ? logIn()
                : applicationStatus === 'CUSTOMER_CREATE_SUCCESS_IDV_PENDING' ||
                  applicationStatus === 'SECONDARY_CUSTOMER_CREATE_SUCCESS_WITH_IDV_PENDING'
                ? onboardingPending()
                : customerService()
            "
          >
            {{
              applicationStatus === 'ACCOUNT_CREATE_SUCCESS'
                ? $t(`onboardStatus.activateDB`)
                : $t(`onboardStatus.exit`)
            }}
          </v-btn>
        </div>
      </v-card>
      <!-- this v-card is to handle the final screens with different application status end -->
      <!-- this v-card is for LISA failure screens start -->
      <v-card flat class="justify-center align-center" v-else-if="isLisaError !== ''">
        <h4
          class="onboarding-screenTitle text-none pb-14"
          :style="{ 'font-family': customCSS && customCSS['formTitle-fontFamily'] }"
        >
          <v-icon :color="isLisaError === 'pending' ? 'warning' : 'error'">
            {{ isLisaError === 'pending' ? 'mdi-alert-outline' : 'mdi-alert-circle-outline' }}
          </v-icon>
          <span v-if="isLisaError === 'pending'">
            {{ $t(`onboardStatus.lisaAccountCreationPendingTitle`) }}
          </span>
          <span v-else> {{ $t(`onboardStatus.lisaAccountCreationFailureTitle`) }} </span>
        </h4>
        <div class="text-center">
          <img src="@/assets/dco/finalPage.png" class="finalScreen-Image" width="390px" />
        </div>
        <div class="pt-14">
          <div>
            <h3
              class="onboarding-title"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
            >
              {{ $t(`onboardStatus.lisaHelperTitle`) }}
            </h3>
            <p
              class="onboarding-subTitle mb-2"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
            >
              <span v-if="isLisaError === 'badRequest'"
                >{{ $t(`onboardStatus.lisaBadRequest`) }}
                <span class="font-weight-bold">
                  {{ $t(`onboardStatus.lisaBadRequestReason`) }}.</span
                ></span
              >
              <span
                v-else-if="
                  isLisaError === 'investorNotFound' ||
                  isLisaError === 'investorAlreadyExists' ||
                  isLisaError === 'matchingRecordNotFound'
                "
                >{{ $t(`onboardStatus.lisaInvestorNotFound`)
                }}<span class="font-weight-bold"> {{ formattedLisaError }}</span>
              </span>
              <span v-else-if="isLisaError === 'pending'"
                >{{ $t(`onboardStatus.lisapending`) }}
                <span class="font-weight-bold"> {{ $t(`onboardStatus.helplineNumber`) }}</span>
                {{ $t(`onboardStatus.or`) }}
                <span class="font-weight-bold">{{ $t(`onboardStatus.helplineEmail`) }}.</span></span
              >
            </p>
            <p
              class="onboarding-subTitle mb-2"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
            >
              <span
                >{{ $t(`onboardStatus.lisaHelper`)
                }}<span class="font-weight-bold"> {{ $t(`onboardStatus.helplineNumber`) }}</span>
                {{ $t(`onboardStatus.or`) }}
                <span class="font-weight-bold">{{ $t(`onboardStatus.helplineEmail`) }}.</span>
              </span>
            </p>
            <p
              class="onboarding-subTitle mb-2"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
            >
              {{ $t(`onboardStatus.lisaHelper1`) }}
            </p>
            <p
              class="onboarding-subTitle"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              }"
            >
              {{ $t(`onboardStatus.accountCreationFailHelper1`) }}
            </p>
            <v-row class="justify-center align-center mb-0">
              <v-col>
                <p
                  class="onboarding-subTitle1"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t(`onboardStatus.applicationNumber`) }}
                </p>
                <h5
                  class="onboarding-content"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ applicationNumber }}
                </h5>
              </v-col>
            </v-row>
            <div class="text-center mt-16">
              <v-btn
                rounded
                :color="customCSS['primary']"
                outlined
                class="justify-center align-center"
                @click="onboardingPending()"
              >
                {{ $t(`onboardStatus.exit`) }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>
      <!-- this v-card is for LISA failure screens end -->
      </div>
    </v-row>
  </v-container>
</template>
<script>
import store from '@/store';
import routeMixin from '@/_core/mixins/routeMixin.js';
import appSettings from '@/plugins/appSettings';
import * as colors from '@/_core/util/themeUtility';
export default {
  name: 'OnboardStatus',
  mixins: [routeMixin],
  data() {
    return this.getInitialData();
  },
  created() {
    this.customCSS = colors.colors;
  },
  methods: {
    getInitialData() {
      return {
        applicationStatus: '',
        onboardTitle: '',
        onboardHelper: '',
        onboardHelper1: '',
        onboardHelper2: '',
        onboardHelperIdvFailure: '',
        screenTitle: '',
        isLisaError: '',
        ebavStatusFlag: false,
        applicationNumber: null,
        bankSite: this.$t('onboardStatus.urlOne'),
        bankSiteLink: this.$t('onboardStatus.urlTwo'),
        partyCreationFailed: false,
        secondaryPartyFailed: false,
        partyId: null,
        secondaryPartyId: null,
        accountNumber: null,
        url: null,
        ebavLink: null,
        secondaryApplicantUrl: null,
        applicationDown: false,
        customCSS: {},
        modalConfig: {
          enabled: false,
          icon: 'mdi-timer',
          persistent: true,
          saveButton: 'OK',
          title: this.$t('common.idleTimeoutTitle'),
          width: 450,
        },
      };
    },
    customerService() {
      const customerServiceUrl = appSettings.dco.customerService;

      if (customerServiceUrl) {
        window.location.href = customerServiceUrl;
      }
    },
    onboardingPending() {
      const onboardingPendingStateUrl = appSettings.dco.onboardingPendingState;

      if (onboardingPendingStateUrl) {
        window.location.href = onboardingPendingStateUrl;
      }
    },
    logIn() {
      const logIn = this.$appSettings.dco.logIn;

      window.location.href = logIn;
    },
    redirectToThirdParty(url) {
      window.open(url);
    },
    partyOnboardingStatus(reviewMappingData) {
      let onboardTitle, onboardHelper, onboardHelper1, onboardHelper2, screenTitle, onboardHelperIdvFailure;
      const otherInformation = reviewMappingData && reviewMappingData.otherInformation ? JSON.parse(reviewMappingData.otherInformation) : null;
      const statusInformation = reviewMappingData && reviewMappingData.statusInformation ? JSON.parse(reviewMappingData.statusInformation) : null;

      this.applicationStatus = reviewMappingData?.applicationStatus;
      this.url = reviewMappingData?.url ? reviewMappingData.url : otherInformation?.identityVerificationDetails?.primaryApplicantDocumentUploadLinkRN
        ? otherInformation?.identityVerificationDetails?.primaryApplicantDocumentUploadLinkRN : null;
      this.ebavLink = reviewMappingData?.ebavLink !== undefined ? reviewMappingData.ebavLink : statusInformation?.ebavLink;
      this.secondaryApplicantUrl = reviewMappingData?.secondaryApplicantUrl ? reviewMappingData.secondaryApplicantUrl : otherInformation?.identityVerificationDetails?.secondaryApplicantDocumentUploadLinkRN
        ? otherInformation?.identityVerificationDetails?.secondaryApplicantDocumentUploadLinkRN : null;
      this.applicationNumber = reviewMappingData?.applicationNumber ? reviewMappingData.applicationNumber : localStorage.getItem('applicationNumber');
      this.secondaryPartyId = otherInformation?.secondaryCustomerId ? otherInformation.secondaryCustomerId : reviewMappingData?.secondaryPartyId
        ? reviewMappingData?.secondaryPartyId : null;
      this.partyId = reviewMappingData?.customerId ? reviewMappingData?.customerId : reviewMappingData?.partyId ? reviewMappingData?.partyId : null;
      this.accountNumber = reviewMappingData?.accountNumber ? reviewMappingData?.accountNumber : otherInformation && otherInformation.accountId != null
        ? otherInformation.accountId : null;
      this.applicationStatus = reviewMappingData?.applicationStatus;
      this.ebavStatusFlag = reviewMappingData?.ebavStatusFlag !== undefined && reviewMappingData?.ebavStatusFlag !== null ? reviewMappingData.ebavStatusFlag.toUpperCase() : statusInformation?.ebavStatusFlag != null ? statusInformation?.ebavStatusFlag.toUpperCase() : false;
      //   Assigning the onbaording status page text based on application status.
      if (this.applicationStatus === 'CUSTOMER_CREATE_SUCCESS_IDV_PENDING') {
        if (this.url !== null) {
          onboardTitle = `${this.$t('onboardStatus.pendingWithUrl')}`;
          onboardHelper = `${this.$t('onboardStatus.pendingWithUrlHelper')}`.split(/{{|}}/).filter(Boolean);
          onboardHelper1 = `${this.$t('onboardStatus.pendingWithUrlHelper1')}`;
        } else {
          onboardTitle = this.$te('onboardStatus.pending') ? this.$t('onboardStatus.pending') : this.$t('onboardStatus.pendingWithTitle');
          onboardHelper = this.$te('onboardStatus.pendingHelper') ? this.$t('onboardStatus.pendingHelper') : '';
        }
      } else if (this.applicationStatus === 'SECONDARY_CUSTOMER_CREATE_SUCCESS_WITH_IDV_PENDING' || this.applicationStatus === 'SECONDARY_CUSTOMER_CREATE_SUCCESS_WITH_PRIMARY_IDV_PENDING' ||
        this.applicationStatus === 'PRIMARY_SECONDARY_CUSTOMER_CREATE_SUCCESS_WITH_BOTH_IDV_PENDING'
      ) {
        if (this.url !== null && this.secondaryApplicantUrl !== null) {
          onboardTitle = `${this.$t('onboardStatus.jointApplicantPendingTitle')}`;
          onboardHelper = `${this.$t('onboardStatus.jointApplicantPendingHelper')}`.split(/{{|}}/).filter(Boolean);
          onboardHelper1 = `${this.$t('onboardStatus.pendingWithUrlHelper1')}`;
        } else if (this.url !== null && this.secondaryApplicantUrl === null) {
          onboardTitle = `${this.$t('onboardStatus.primaryApplicantPendingTitle')}`;
          onboardHelper = `${this.$t('onboardStatus.primaryApplicantPendingHelper')}`.split(/{{|}}/).filter(Boolean);
          onboardHelper1 = `${this.$t('onboardStatus.pendingWithUrlHelper1')}`;
        } else if (this.url === null && this.secondaryApplicantUrl !== null) {
          onboardTitle = `${this.$t('onboardStatus.secondaryApplicantPendingTitle')}`;
          onboardHelper = `${this.$t('onboardStatus.secondaryApplicantPendingHelper')}`.split(/{{|}}/).filter(Boolean);
          onboardHelper1 = `${this.$t('onboardStatus.pendingWithUrlHelper1')}`;
        } else if (this.applicationStatus === 'SECONDARY_CUSTOMER_CREATE_SUCCESS_WITH_IDV_PENDING' && this.secondaryApplicantUrl === null) {
          onboardTitle = `${this.$t('onboardStatus.secondaryApplicantPendingNoUrlTitle')}`;
          onboardHelper = `${this.$t('onboardStatus.secondaryApplicantPendingNoUrlHelper')}`;
          onboardHelper1 = `${this.$t('onboardStatus.pendingWithUrlHelper1')}`;
        } else if (this.applicationStatus === 'SECONDARY_CUSTOMER_CREATE_SUCCESS_WITH_PRIMARY_IDV_PENDING' && this.url === null) {
          onboardTitle = `${this.$t('onboardStatus.primaryApplicantPendingNoUrlTitle')}`;
          onboardHelper = `${this.$t('onboardStatus.primaryApplicantPendingNoUrlHelper')}`;
          onboardHelper1 = `${this.$t('onboardStatus.pendingWithUrlHelper1')}`;
        } else {
          onboardTitle = `${this.$t('onboardStatus.jointApplicantPendingNoUrlTitle')}`;
          onboardHelper = `${this.$t('onboardStatus.jointApplicantPendingNoUrlHelper')}`;
          onboardHelper1 = `${this.$t('onboardStatus.pendingWithUrlHelper1')}`;
        }
      } else if (this.applicationStatus === 'CUSTOMER_CREATE_SUCCESS_SECONDARY_CUSTOMER_BLOCKED' || this.applicationStatus === 'CUSTOMER_CREATE_SUCCESS_WITH_PRIMARY_IDV_PENDING_SECONDARY_CUSTOMER_BLOCKED') {
        if (this.applicationStatus === 'CUSTOMER_CREATE_SUCCESS_WITH_PRIMARY_IDV_PENDING_SECONDARY_CUSTOMER_BLOCKED' && this.url !== null) {
          onboardTitle = `${this.$t('onboardStatus.secondaryFailWithPrimaryIDVPendingTitle')}`;
          onboardHelper = `${this.$t('onboardStatus.secondaryFailWithPrimaryIDVPendingHelper')}`.split(/{{|}}/).filter(Boolean);
        } else if (this.applicationStatus === 'CUSTOMER_CREATE_SUCCESS_WITH_PRIMARY_IDV_PENDING_SECONDARY_CUSTOMER_BLOCKED' && this.url === null) {
          onboardTitle = `${this.$t('onboardStatus.secondaryFailWithPrimaryIDVPendingTitle1')}`;
          onboardHelper = `${this.$t('onboardStatus.secondaryFailWithPrimaryIDVPendingHelper1')}`;
        } else {
          onboardTitle = `${this.$t('onboardStatus.secondaryApplicantFailTitle')}`;
          onboardHelper = `${this.$t('onboardStatus.secondaryApplicantFailHelper')}`;
        }
      } else if (this.applicationStatus === 'CUSTOMER_CREATE_SUCCESS_IDV_FAILURE') {
        onboardTitle = `${this.$t('onboardStatus.onboardFail')}`;
        onboardHelper = `${this.$t('onboardStatus.onboardFailHelper')}`;
        onboardHelperIdvFailure = `${this.$t('onboardStatus.pendingWithUrlHelperIdvFailure')}`;
      } else if (this.ebavStatusFlag === 'REFERRAL' && this.applicationStatus === 'ACCOUNT_CREATE_SUCCESS') {
        if (this.ebavLink !== null) {
          onboardHelper = `${this.$t('onboardStatus.idvComplaintEbavReferralWithUrl')}`.split(/{{|}}/).filter(Boolean);
          onboardHelper1 = `${this.$t('onboardStatus.idvComplaintEbavReferralWithUrlHelper1')}`;
          onboardHelper2 = `${this.$t('onboardStatus.idvComplaintEbavReferralHelper2')}`;
        } else if (this.ebavLink === null) {
          onboardHelper = `${this.$t('onboardStatus.idvComplaintEbavReferralWithoutUrlHelper')}`;
          onboardHelper2 = `${this.$t('onboardStatus.idvComplaintEbavReferralHelper2')}`;
        }
      } else if (this.ebavStatusFlag === 'REFERRAL' && this.applicationStatus === 'ACCOUNT_CREATE_FAILED') {
        if (this.ebavLink !== null) {
          onboardHelper = `${this.$t('onboardStatus.idvComplaintEbavReferralFailureWithUrlHelper')}`.split(/{{|}}/).filter(Boolean);
          onboardHelper1 = `${this.$t('onboardStatus.idvComplaintEbavReferralWithUrlHelper1')}`;
          onboardHelper2 = `${this.$t('onboardStatus.idvComplaintEbavReferralHelper2')}`;
        } else if (this.ebavLink === null) {
          onboardHelper = `${this.$t('onboardStatus.idvComplaintEbavReferralFailureWithoutUrlHelper')}`;
          onboardHelper2 = `${this.$t('onboardStatus.idvComplaintEbavReferralHelper2')}`;
        }
      } else if (this.applicationStatus === 'ACCOUNT_CREATE_FAILED') {
        screenTitle = `${this.$t('onboardStatus.accountCreationFailTitle')}`;
        onboardTitle = `${this.$t('onboardStatus.accountCreationFailTitle')}`;
        onboardHelper =
          this.secondaryPartyId !== null && this.secondaryPartyId !== undefined
            ? `${this.$t('onboardStatus.jointaccountOpeningFailHelper')}`
            : `${this.$t('onboardStatus.accountCreationFailHelper')}`;
        onboardHelper1 = `${this.$t('onboardStatus.accountCreationFailHelper1')}`;
      } else if (
        this.applicationStatus === 'CUSTOMER_CREATE_FAILED' ||
        (reviewMappingData?.status === 400 && reviewMappingData?.causes[0]?.code !== 'FEDE-000193')
      ) {
        this.partyCreationFailed = true;
        screenTitle = `${this.$t('onboardStatus.partyCreationFailTitle')}`;
        onboardTitle = `${this.$t('onboardStatus.partyCreationFailHelper')}`;
        onboardHelper = `${this.$t('onboardStatus.partyCreationFailHelper1')}`;
        onboardHelper1 = `${this.$t('onboardStatus.accountCreationFailHelper1')}`;
      } else if (
        this.applicationStatus === 'SECONDARY_CUSTOMER_CREATE_FAILED' ||
        (reviewMappingData?.status === 400 && reviewMappingData?.causes[0]?.code === 'FEDE-000193')
      ) {
        this.secondaryPartyFailed = true;
        screenTitle = `${this.$t('onboardStatus.partyCreationFailTitle')}`;
        onboardTitle = `${this.$t('onboardStatus.secondaryPartyCreationFailHelper')}`;
        onboardHelper = `${this.$t('onboardStatus.secondaryPartyCreationFailHelper1')}`;
        onboardHelper1 = `${this.$t('onboardStatus.accountCreationFailHelper1')}`;
      } else if (this.applicationStatus === 'ACCOUNT_CREATE_SUCCESS') {
        if (this.secondaryPartyId !== null) {
          onboardTitle = `${this.$t('onboardStatus.secondaryOnboardSuccess')}`;
          onboardHelper = `${this.$t('onboardStatus.onboardSuccessHelper')}`;
          onboardHelper1 = `${this.$t('onboardStatus.accountCreationFailHelper1')}`;
        } else {
          onboardTitle = `${this.$t('onboardStatus.onboardSuccess')}`;
          onboardHelper = `${this.$t('onboardStatus.onboardSuccessHelper')}`;
          onboardHelper1 = `${this.$t('onboardStatus.accountCreationFailHelper1')}`;
        }
      } else if (this.applicationStatus === 'IDV_PENDING_EBAV_ACCEPTED') {
        if (this.url !== null) {
          onboardTitle = `${this.$t('onboardStatus.ebavReferralIdvPendingTitle')}`;
          onboardHelper = `${this.$t('onboardStatus.ebavReferralIdvPendingWithUrl')}`.split(/{{|}}/).filter(Boolean);
          onboardHelper1 = `${this.$t('onboardStatus.idvPendingHelper1')}`;
        } else if (this.url === null) {
          onboardTitle = `${this.$t('onboardStatus.ebavReferralIdvPendingWithoutUrlTitle')}`;
          onboardHelper = `${this.$t('onboardStatus.ebavReferralIdvPendingWithoutUrlHelper')}`;
          onboardHelper1 = `${this.$t('onboardStatus.idvPendingHelper1')}`;
        }
      } else if (this.applicationStatus === 'IDV_PENDING_EBAV_REFERRAL') {
        if (this.url !== null && this.ebavLink !== null) {
          onboardTitle = `${this.$t('onboardStatus.idvPendingEbavStatusReferralTitle')}`;
          onboardHelper = `${this.$t('onboardStatus.idvPendingEbavStatusReferralWithUrlEbavLinkHelper')}`;
          onboardHelper1 = `${this.$t('onboardStatus.idvPendingHelper1')}`;
        } else if (this.url !== null && this.ebavLink === null) {
          onboardTitle = `${this.$t('onboardStatus.idvPendingEbavStatusReferralTitle')}`;
          onboardHelper = `${this.$t('onboardStatus.idvPendingEbavStatusReferralWithUrlHelper')}`.split(/{{|}}/).filter(Boolean);
          onboardHelper1 = `${this.$t('onboardStatus.idvPendingHelper1')}`;
        } else if (this.url === null && this.ebavLink !== null) {
          onboardTitle = `${this.$t('onboardStatus.idvPendingEbavStatusReferralTitle')}`;
          onboardHelper = `${this.$t('onboardStatus.idvPendingEbavStatusReferralWithEbavLinkHelper')}`.split(/{{|}}/).filter(Boolean);
          onboardHelper1 = `${this.$t('onboardStatus.idvPendingHelper1')}`;
        } else if (this.url === null && this.ebavLink === null) {
          onboardTitle = `${this.$t('onboardStatus.idvPendingEbavStatusReferralTitle')}`;
          onboardHelper = `${this.$t('onboardStatus.idvPendingEbavStatusReferralWithoutUrlEbavLinkHelper')}`;
          onboardHelper1 = `${this.$t('onboardStatus.idvPendingHelper1')}`;
        }
      } else if (this.applicationStatus === 'IDV_PENDING_EBAV_ERROR') {
        if (this.url !== null) {
          onboardTitle = `${this.$t('onboardStatus.idvPendingEbavStatusErrorTitle')}`;
          onboardHelper = `${this.$t('onboardStatus.idvPendingEbavStatusErrorWithUrlHelper')}`;
          onboardHelper1 = `${this.$t('onboardStatus.idvPendingHelper1')}`;
          onboardHelper2 = `${this.$t('onboardStatus.idvPendginEbavStatusErrorWithUrlHelper2')}`.split(/{{|}}/).filter(Boolean);
        } else if (this.url === null) {
          onboardTitle = `${this.$t('onboardStatus.idvPendingEbavStatusErrorTitle')}`;
          onboardHelper = `${this.$t('onboardStatus.idvPendingEbavStatusErrorWithoutUrlHelper')}`;
          onboardHelper1 = `${this.$t('onboardStatus.idvPendingHelper1')}`;
        }
      } else if (this.applicationStatus === 'CUSTOMER_CREATE_SUCCESS_EBAV_ERROR') {
        onboardTitle = `${this.$t('onboardStatus.idvComplaintEbavStatusErrorTitleForTermDeposit')}`;
        onboardHelper = `${this.$t('onboardStatus.idvComplaintEbavStatusErrorHelper')}`;
        onboardHelper1 = `${this.$t('onboardStatus.idvComplaintHelper1')}`;
      } else {
        screenTitle = `${this.$t('onboardStatus.applicationDownTitle')}`;
        onboardTitle = `${this.$t('onboardStatus.applicationDownTitle')}`;
        onboardHelper = `${this.$t('onboardStatus.applicationDownHelper')}`;
        onboardHelper1 = `${this.$t('onboardStatus.accountCreationFailHelper1')}`;
      }
      this.onboardTitle = onboardTitle;
      this.onboardHelper = onboardHelper;
      this.onboardHelper1 = onboardHelper1;
      this.onboardHelperIdvFailure = onboardHelperIdvFailure;
      this.screenTitle = screenTitle;
      this.onboardHelper2 = onboardHelper2;
      if (reviewMappingData?.causes) {
        // This if block is for the new onboarding submit process.
        this.partyCreationFailed = !reviewMappingData.causes[0].message.includes('LISA') && reviewMappingData.causes[0].code !== 'FEDE-000193';
        this.isLisaError = reviewMappingData.causes[0].message.includes('LISA') ? reviewMappingData.causes[0].message.includes('BAD_REQUEST') ? 'badRequest' : reviewMappingData.causes[0].message.includes('INVESTOR_NOT_FOUND')
          ? 'investorNotFound' : reviewMappingData.causes[0].message.includes('INVESTOR_ALREADY_EXISTS') ? 'investorAlreadyExists' : reviewMappingData.causes[0].message.includes('MATCHING_RECORD_NOT_FOUND')
            ? 'matchingRecordNotFound' : 'pending' : '';

        const splitLisaErrorMessage = reviewMappingData.causes[0].message.split('.');

        this.formattedLisaError =
          splitLisaErrorMessage[0].split(' ') && splitLisaErrorMessage[0].split(' ')[6]
            ? splitLisaErrorMessage[0].split(' ')[6].replaceAll('_', ' ')
            : '';
        this.applicationDown = reviewMappingData?.status === 500;
        this.secondaryPartyFailed = reviewMappingData.causes[0].code === 'FEDE-000193';
        if (this.secondaryPartyFailed) {
          const match = reviewMappingData.causes[0].message.match(/Primary customer id is (\d+)/);
          this.partyId = match ? match[1] : null;
        }
      } else {
        // This else block is for resume process.
        this.isLisaError = reviewMappingData && reviewMappingData?.applicationStatus && reviewMappingData?.applicationStatus === 'CUSTOMER_CREATE_SUCCESS_LISA_REJECTED' ? 'badRequest' : '';
        // Assigninging the application down flag when through resume process.
        this.applicationDown = this.applicationStatus !== 'ACCOUNT_CREATE_FAILED' && ((statusInformation && statusInformation?.partyConsentSaved === false) ||
        (otherInformation && otherInformation?.accountId !== null && statusInformation && statusInformation?.accountConsentSaved === false) || this.applicationStatus === 'CUSTOMER_CREATE_SUBMITTED' || this.applicationStatus === 'CUSTOMER_CREATE_SUCCESS_EBAV_SUBMITTED' || this.applicationStatus === 'EBAV_ACCEPTED_NOM_ACC_SUBMITTED' || this.applicationStatus === 'EBAV_REFERRAL_NOM_ACC_SUBMITTED');
        // Assigninging the party creation fail flag when through resume process.
        this.partyCreationFailed = reviewMappingData && (reviewMappingData?.applicationStatus === 'CUSTOMER_CREATE_FAILED' || (reviewMappingData?.applicationStatus === 'CUSTOMER_CREATE_SUBMITTED' && reviewMappingData?.customerId === null && reviewMappingData?.customerId === undefined));
      }
    },
  },
  watch: {
    async $route(to, from) {
      if (this.currentActionRoute === 'onboardStatus') {
        window.scrollTo(0, 0);
        const reviewMappingData = store.getters['userStore/userData']?.additionalInfoData;
        const data = reviewMappingData?.data ? reviewMappingData?.data : reviewMappingData;
        this.partyOnboardingStatus(data);
      }
    },
  },
};
</script>
